import { CircularProgress } from "@mui/material";
import Box from "../Box";
import Typography from "../Typography";
import useStrings from "../../hooks/useStrings";

export const DataNotFound = () => {
    const Strings = useStrings();
    return (
        <Wrapper>
            <NoDataIcon />
            <Typography variant="caption">{Strings.Common.NO_DATA}</Typography>
        </Wrapper>
    );
};

export const DataLoading = () => {
    return (
        <Wrapper>
            <CircularProgress />
        </Wrapper>
    );
};

const Wrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <Box
            sx={{
                height: "40vh",
                backgroundColor: "#f3f3f3",
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            {children}
        </Box>
    );
};

const NoDataIcon = () => (
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="512.000000pt"
        height="512.000000pt"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet"
        style={{
            width: 55,
            height: 55,
        }}
    >
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                d="M2542 4339 c-171 -29 -319 -107 -453 -239 -97 -95 -139 -156 -190
   -275 -24 -55 -28 -60 -55 -57 -16 2 -92 4 -169 5 -118 1 -152 -2 -217 -20
   -245 -71 -429 -220 -545 -441 -37 -71 -40 -74 -105 -101 -144 -61 -301 -196
   -377 -324 -236 -399 -76 -950 333 -1147 146 -70 199 -81 418 -87 163 -5 191
   -3 212 11 52 33 57 85 14 126 -20 18 -35 20 -175 20 -100 0 -181 5 -231 16
   -114 23 -229 82 -312 160 -136 129 -199 265 -208 447 -9 201 47 345 188 488
   70 71 100 94 171 128 47 22 92 41 100 41 31 0 62 35 98 113 66 143 156 243
   288 323 132 79 327 112 473 79 171 -38 190 -32 216 70 49 191 182 354 359 440
   101 49 191 68 315 68 198 -1 349 -62 480 -193 87 -88 129 -154 170 -270 16
   -47 37 -91 47 -98 20 -15 47 -13 178 12 141 27 302 14 455 -36 359 -117 597
   -436 617 -828 13 -265 -72 -501 -245 -682 -152 -159 -329 -244 -577 -279 -44
   -6 -87 -15 -97 -20 -31 -17 -40 -87 -15 -118 23 -28 57 -31 164 -15 241 35
   440 128 601 278 429 402 443 1124 29 1553 -237 245 -605 362 -972 308 l-40 -6
   -25 58 c-61 143 -201 301 -339 383 -168 100 -387 141 -579 109z"
            />
            <path
                d="M2430 2680 c-490 -69 -858 -514 -826 -1000 8 -125 46 -273 96 -379
   158 -329 485 -531 860 -531 562 0 983 444 957 1010 -6 127 -24 207 -72 321
   -115 273 -368 489 -655 559 -98 23 -266 33 -360 20z m390 -199 c321 -109 519
   -374 537 -721 12 -221 -59 -416 -210 -577 -138 -147 -308 -232 -504 -252 -394
   -40 -755 212 -860 599 -26 95 -23 298 6 405 68 252 242 447 476 535 111 41
   172 50 320 46 126 -2 149 -6 235 -35z"
            />
            <path
                d="M2193 2105 c-27 -19 -38 -67 -23 -97 7 -13 71 -83 143 -155 l131
   -133 -142 -143 c-121 -122 -142 -148 -142 -174 0 -42 28 -72 73 -80 38 -6 38
   -5 183 138 l144 143 133 -131 c135 -134 160 -153 197 -153 32 0 70 44 70 81 0
   28 -18 51 -142 176 l-142 143 142 143 c124 125 142 148 142 176 0 43 -38 81
   -81 81 -28 0 -51 -18 -176 -142 l-143 -142 -143 142 c-153 151 -173 163 -224
   127z"
            />
        </g>
    </svg>
);
